import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Header } from '../../Header';
import { Footer } from '../../Footer';
import { SupportedBrowsersOnly } from '../../SupportedBrowsersOnly';
import { NoScript } from '../../NoScript';
import type { ContentUserT } from '../../../state/user';
interface Props {
  headerElement?: React.ReactNode;
  footerElement?: React.ReactNode;
  fullHeight?: boolean;
  children: React.ReactNode;
  user: ContentUserT;
}

export function Page({
  user,
  fullHeight = true,
  headerElement = <Header user={user} />,
  footerElement = <Footer />,
  children,
}: Props) {
  return (
    <SupportedBrowsersOnly>
      <NoScript />
      {fullHeight ? (
        <Box
          minHeight="100vh"
          flexDirection="column"
          alignItems="stretch"
          justifyContent="stretch"
        >
          {headerElement}
          <Box
            as="main"
            flex="1"
            flexDirection="column"
            alignItems="stretch"
            justifyContent="stretch"
          >
            {children}
          </Box>
          {footerElement}
        </Box>
      ) : (
        <>
          {headerElement}
          <main>{children}</main>
          {footerElement}
        </>
      )}
    </SupportedBrowsersOnly>
  );
}
